import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { setConfirmModalFields } from '../appRedux/actions';
import FormModal from '../components/FormModal';
import { FormattedMessage } from 'react-intl';
import {
  CardBody,
  InputGroup,
  FormSelect,
  InputGroupAddon,
  InputGroupText,
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  FormInput,
  FormCheckbox,
  ButtonGroup,
  Button,
} from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import {
  requestServices,
  requestCreateService,
  requestUpdateService,
  requestDeleteService,
  requestSearchServices,
} from '../appRedux/thunks/services';

function getTableColumns () {
  return [
    {
      Header: () => this.state.selectedServiceIds.length ? <span onClick={this.onClickDelete} className="text-danger">Delete</span> : <FormattedMessage id="select" defaultMessage="Select" />,
      accessor: 'select',
      maxWidth: 60,
      className: 'text-center',
      Cell: row => (
        <FormCheckbox
          className="ml-auto my-auto"
          name="select-service"
          checked={this.state.selectedServiceIds.includes(row.original.sequence_num)}
          onChange={() => this.onSelectService(row.original.sequence_num)}
        />),
    },
    {
      Header: <FormattedMessage id="id" defaultMessage="ID" />,
      accessor: 'sequence_num',
      maxWidth: 60,
      className: 'text-center',
    },
    {
      Header: <FormattedMessage id="title" defaultMessage="Title" />,
      accessor: 'title',
      className: 'text-center',
      minWidth: 200,
    },
    {
      Header: <FormattedMessage id="description" defaultMessage="Description" />,
      accessor: 'description',
      className: 'text-center',
    },
    {
      Header: <FormattedMessage id="actions" defaultMessage="Actions" />,
      accessor: 'actions',
      className: 'text-center',
      maxWidth: 150,
      Cell: row => (
        <ButtonGroup size="sm" className="d-table mx-auto">
          <Button theme="white" onClick={() => this.onClickEdit(row)}>
            <i className="material-icons">edit</i>
          </Button>
          <Button theme="white" onClick={() => this.onClickDelete(row.original.sequence_num)}>
            <i className="material-icons">delete</i>
          </Button>
        </ButtonGroup>
      ),
    },
  ];
}


class Services extends React.Component {
  constructor () {
    super();
    this.state = {
      editingServiceObject: {},
      openAddNewModal: false,
      openEditingServiceModal: false,
      selectedServiceIds: [],
      pageSizeOptions: [5, 10, 15, 20, 25, 30],
      pageSize: 10,
      tableData: [],
      errors: {},
    };

    this.tableColumns = getTableColumns.call(this);
  }

  onChangeModalInput = (e) => {
    const valid = e.target.value.length > 2;
    const name = e.target.name;

    this.setState({ errors: { ...this.state.errors, [name]: valid } });
  }

  getModalContent = service => (
    <Row>
      <Col lg="12">
        <Row form>
          <Col lg="12" className="form-group">
            <label htmlFor="company"><FormattedMessage id="title" defaultMessage="Title" /></label>
            <FormInput
              id="title"
              name="title"
              valid={this.state.errors.title}
              invalid={this.state.errors.title === false}
              defaultValue={service.title}
              onChange={this.onChangeModalInput}
              required
            />
          </Col>
        </Row>
        <Row form>
          <Col md="12" className="form-group">
            <label htmlFor="company"><FormattedMessage id="description" defaultMessage="Desciption" /></label>
            <FormInput
              id="description"
              name="description"
              size="lg"
              defaultValue={service.description}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )

  componentDidMount () {
    this.props.requestServices();
  }

  handlePageSizeChange = (e) => {
    const pageSize = e.target ? e.target.value : this.props.services.pageSize;
    const page = !e.target ? e : this.props.services.page;

    this.props.requestItems(page, pageSize);
  }

  // Edit item
  onClickEdit = (row) => {
    this.setState({ editingServiceObject: row.original, openEditingServiceModal: true });
  }

  // Add new item
  onClickAddNew = () => {
    this.setState({ openAddNewModal: true });
  }

  // Update submit
  onSubmitService = (event, serviceId) => {
    const newService = { serviceId, description: event.target.description.value, title: event.target.title.value };

    if (serviceId) {
      this.props.requestUpdateService(newService);
    } else {
      this.props.requestCreateService(newService);
    }
    this.onClickCloseModal();
  }

  // delete one or multiple services
  onClickDelete = (id) => {
    const idArray = (typeof id === 'object') ? this.state.selectedServiceIds : [id];

    if (!idArray.length) return;
    this.props.setConfirmModalFields({
      callBack: () => this.props.requestDeleteService(idArray),
      message: <FormattedMessage id="delete_service_message" defaultMessage="Are you sure you want to delete the selected item(s)?" />,
      open: true,
      title: <FormattedMessage id="delete" defaultMessage="Delete" />,
    });
  }

  // close modal
  onClickCloseModal = () => {
    this.setState({
      openAddNewModal: false,
      openEditingServiceModal: false,
      editingServiceObject: {},
      errors: {},
    });
  }

  handleFilterSearch = (e) => {
    const text = e.target.value;

    this.props.requestSearchServices(text);
  }

  // select multiple items
  onSelectService = (id) => {
    const { selectedServiceIds } = this.state;

    this.setState({
      selectedServiceIds: !selectedServiceIds.includes(id)
        ? [...selectedServiceIds, id] : selectedServiceIds.filter(sId => sId !== id),
    });
  }

  render () {
    const { editingServiceObject } = this.state;
    const content = this.getModalContent(editingServiceObject);
    const { records = [], pageSizeOptions, pageSize, pages, page } = this.props.services;


    return (
      <div>
        <FormModal content={content} title={<FormattedMessage id="add" defaultMessage="Add New" />} onSubmit={this.onSubmitService} open={this.state.openAddNewModal} onClose={this.onClickCloseModal}/>
        <FormModal content={content} title={<FormattedMessage id="edit" defaultMessage="Edit" />} objectId={editingServiceObject.sequence_num} service={editingServiceObject} onSubmit={this.onSubmitService} open={this.state.openEditingServiceModal} onClose={this.onClickCloseModal} />
        <Container className="main-content-container px-4 pb-4">
          <Row noGutters className="page-header py-4">
            <PageTitle title={<FormattedMessage id="services" defaultMessage="Services" />} subtitle={<FormattedMessage id="service_desc" defaultMessage="select or search services below" />} className="text-sm-left mb-3" />
            <Col sm="4" className="d-flex ml-auto my-auto justify-content-end">
              <Button onClick={this.onClickAddNew}><i className="material-icons mr-2">add</i><FormattedMessage id="add_new_service" defaultMessage="Add New Service" /></Button>
            </Col>
          </Row>
          <Card className="p-0">
            <CardHeader className="p-0">
              <Container fluid className="file-manager__filters border-bottom">
                <Row>

                  <Col className="file-manager__filters__rows d-flex" md="6">
                    <span><FormattedMessage id="show_rows" defaultMessage="Number of Rows"/></span>
                    <FormSelect
                      size="sm"
                      value={pageSize}
                      onChange={this.handlePageSizeChange}
                    >
                      {pageSizeOptions.map((size, idx) => (
                        <option key={idx} value={size}>
                          {size}
                        </option>
                      ))}
                    </FormSelect>
                  </Col>

                  <Col className="file-manager__filters__search d-flex" md="6">
                    <InputGroup seamless size="sm" className="ml-auto">
                      <InputGroupAddon type="prepend">
                        <InputGroupText>
                          <i className="material-icons">search</i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <FormInput onChange={this.handleFilterSearch} />
                    </InputGroup>
                  </Col>
                </Row>
              </Container>
            </CardHeader>
            <CardBody className="p-0">
              <div className="">
                <ReactTable
                  manual
                  nextText={<FormattedMessage id="next_page" defaultMessage="Next"/>}
                  previousText={<FormattedMessage id="previous_page" defaultMessage="Previous"/>}
                  pageText={<FormattedMessage id="page" defaultMessage="Page"/>}
                  ofText={<FormattedMessage id="of_text" defaultMessage="of"/>}
                  columns={this.tableColumns}
                  data={records}
                  pageSize={pageSize}
                  pages={pages}
                  page={page - 1}
                  showPageSizeOptions={false}
                  resizable={false}
                  onPageChange={this.handlePageSizeChange}
                  className="-striped -highlight"
                />
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  services: state.services,
});

const mapDispatchToProps = {
  requestCreateService,
  requestDeleteService,
  requestServices,
  requestUpdateService,
  setConfirmModalFields,
  requestSearchServices,
};

export default connect(mapStateToProps, mapDispatchToProps)(Services);
